module.exports = __webpack_public_path__ + "static/img/logo02.60e6ffde.jpg";